const UKCyberLaw = () => {
  return (
    <div className='uk-cyber-law'>
      <h2>UK Cyber Law Overview</h2>
      <p>
        In the United Kingdom, cyber law encompasses various statutes and regulations designed to address issues related to
        information technology, cybercrime, data protection, and digital transactions. UK cyber law aims at protecting
        individuals, businesses, and government entities against cyber threats while ensuring the secure and lawful use of
        digital technologies. Key pieces of legislation in this domain include:
      </p>
      <ul>
        <li><strong>Computer Misuse Act 1990:</strong> This Act addresses cybercrime by making unauthorized access to
          computer systems, intent to commit further offenses, and unauthorized modification of computer material illegal.
          It has been updated to reflect technological advancements.</li>
        <li><strong>Data Protection Act 2018:</strong> This Act controls the use of personal information by various entities
          and is the UK's implementation of the GDPR. It outlines a comprehensive data protection framework, detailing
          principles, rights, obligations, and penalties for breaches.</li>
        <li><strong>The Privacy and Electronic Communications (EC Directive) Regulations 2003 (PECR):</strong> PECR
          complements the Data Protection Act by covering the security of public electronic communications services and
          privacy in electronic communications, including the rules on marketing and cookies.</li>
        <li><strong>Network and Information Systems Regulations 2018 (NIS Regulations):</strong> Aimed at improving national
          cybersecurity, this legislation mandates that certain service operators and digital service providers manage risks
          and report significant incidents.</li>
        <li><strong>Investigatory Powers Act 2016:</strong> Known as the "Snoopers' Charter," it outlines the legal
          framework for surveillance, communication interception, and data collection by UK intelligence and law enforcement
          for national security and crime fighting.</li>
        <li><strong>Cyber Security Information Sharing Partnership (CiSP):</strong> Though not a law, CiSP is a governmental
          initiative for sharing information on cyber threats and vulnerabilities to protect UK businesses.</li>
      </ul>
      <p>
        These laws and initiatives form the backbone of UK's approach to cyber law, addressing issues from cybercrime to
        national security in the digital age. Due to the fast pace of technological and cyber threat evolution, UK cyber law
        is under constant review and amendment. For the latest information, it is recommended to consult official government
        sources or legal professionals specializing in this area.
      </p>
    </div>
  );
};

export default UKCyberLaw;